import styled from 'styled-components';
import AcademyThemeContent from './academy-theme-content';
import AwardedAcademyCertification from './awarded-academy-certification';
import withAcademyTheme from './with-academy-theme';

function AwardedAcademyCertificationLandingInner(props) {
  if (props.msg) return <div className="mtxl text-center grey-5 fsm">{props.msg}</div>;

  const { academy } = props;
  const customCertificationOptions = {
    activeCertTemplate: academy.activeCertTemplate,
    certificationColor: academy.certificationColor,
    certificationIssuer: academy.certificationIssuer,
    certificationBackground: academy.certificationBackground,
    certificationLogo: academy.certificationLogo,
    certTemplate2BodyTextColor: academy.certTemplate2BodyTextColor,
    certTemplate2BackgroundImage: academy.certTemplate2BackgroundImage,
    certTemplate2SidebarTextColor: academy.certTemplate2SidebarTextColor,
    certTemplate2ShowId: academy.certTemplate2ShowId,
    certTemplate2ShowDescription: academy.certTemplate2ShowDescription,
  };

  const academyCertificationUserId = window.location.href.split('/').pop();

  return (
    <AcademyThemeContent hasBreadcrumbs={props.hasBreadcrumbs}>
      <CertWrapper>
        <AwardedAcademyCertification
          academyCertificationUserId={academyCertificationUserId}
          academyTitle={academy.title}
          academyId={academy.id}
          academyNameInAwardedCertTitle={academy.academyNameInAwardedCertTitle}
          linkedinOrganizationId={academy.linkedinOrganizationId}
          themeOptions={academy.themeOptions}
          customCertificationOptions={customCertificationOptions}
        />
      </CertWrapper>
    </AcademyThemeContent>
  );
}

const CertWrapper = styled.div`
  box-shadow: 0px 0px 20px 3px rgba(161, 179, 200, 0.7);
  margin: 2rem auto;
  width: 900px;
`;

const AwardedAcademyCertificationLanding = withAcademyTheme(AwardedAcademyCertificationLandingInner);

export default AwardedAcademyCertificationLanding;
